export const FrequencyDefault = {
  DAY: 1,
  HOUR: 8,
  HOURS: 1,
  MINUTE: 0,
  MINUTES: 30,
  THRESHOLD: 3,
  TIME: '8:00 am',
} as const
